// extracted by mini-css-extract-plugin
export var Display1 = "webudvikling-module--Display1--dtlJF";
export var blob1 = "webudvikling-module--blob1--jjwiU";
export var blob2 = "webudvikling-module--blob2--mYpF4";
export var blob3 = "webudvikling-module--blob3--qI6w9";
export var blob4 = "webudvikling-module--blob4--pwFkp";
export var dotPattern1 = "webudvikling-module--dotPattern1--rx6jv";
export var dotPattern2 = "webudvikling-module--dotPattern2--zTzy1";
export var pageNumber = "webudvikling-module--pageNumber--iFNlY";
export var pwa = "webudvikling-module--pwa--I-cJZ";